module.exports = __webpack_public_path__ + "static/media/symbolLogoWhite.21f55a7b.svg";